import {SortTypes} from "../constants";

export default (sort) => {
    const droppedSort = {...sort};
    for (let param in droppedSort) {
        droppedSort[param] = SortTypes.DROPPED.value;
    }
    return droppedSort;
};
